// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetRedebitsListRequestModel from '../../model/get-redebits-list-request-model';
import GetRedebitPaymentStatusLookupRequestModel from '../../model/get-redebit-payment-status-lookup-request-model';
import GetRedebitByIdRequestModel from '../../model/get-redebit-by-id-request-model';
import UploadRedebitsFileRequestModel from '../../model/upload-redebits-file-request-model';
import DownloadUploadStatusReportRequestModel from '../../model/download-upload-status-report-request-model';
import DownloadPaymentStatusReportRequestModel from '../../model/download-payment-status-report-request-model';
import RedebitListPagingResultModel from '../../model/redebit-list-paging-result-model';
import RedebitPaymentStatusListResultModel from '../../model/redebit-payment-status-list-result-model';
import RedebitModel from '../../model/redebit-model';

export default (service: Servicelayer) => ({
  /**  */
  async getRedebitsList(request: GetRedebitsListRequestModel, config?: RequestConfig) {
    const requestDTO = GetRedebitsListRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-redebits-list'] ?? 'redebits';
    const response = await service.get<any>(endpointPath, {
      query: {
        from: requestDTO.from,
        to: requestDTO.to,
        uploadStatusId: requestDTO.uploadStatusId,
        paymentStatus: requestDTO.paymentStatus,
        uploadStatusExported: requestDTO.uploadStatusExported,
        paymentStatusExpored: requestDTO.paymentStatusExpored,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(RedebitListPagingResultModel.toModel(dto));
  },
  /**  */
  async getRedebitPaymentStatusLookup(request: GetRedebitPaymentStatusLookupRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-redebit-payment-status-lookup'] ?? 'redebits/payment-status-lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(RedebitPaymentStatusListResultModel.toModel(dto));
  },
  /**  */
  async getRedebitById(request: GetRedebitByIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetRedebitByIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-redebit-by-id'] ?? 'redebits/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(RedebitModel.toModel(dto));
  },
  /**  */
  async uploadRedebitsFile(request: UploadRedebitsFileRequestModel, config?: RequestConfig) {
    const requestDTO = UploadRedebitsFileRequestModel.toDTO(request);
    const formData = new FormData();
    formData.append('file', requestDTO.file as Blob);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-upload-redebits-file'] ?? 'redebits/upload';
    const response = await service.post<any>(endpointPath, {
      body: formData,
      headers: {
      },
      ...config,
    });
  },
  /**  */
  async downloadUploadStatusReport(request: DownloadUploadStatusReportRequestModel, config?: RequestConfig) {
    const requestDTO = DownloadUploadStatusReportRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-download-upload-status-report'] ?? 'redebits/downloadUploadStatusReport';
    const response = await service.get<any>(endpointPath, {
      responseType: 'blob',
      query: {
        redebitIds: requestDTO.redebitIds,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(new Blob([result], { type: 'application/octet-stream' }));
  },
  /**  */
  async downloadPaymentStatusReport(request: DownloadPaymentStatusReportRequestModel, config?: RequestConfig) {
    const requestDTO = DownloadPaymentStatusReportRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-download-payment-status-report'] ?? 'redebits/downloadPaymentStatusReport';
    const response = await service.get<any>(endpointPath, {
      responseType: 'blob',
      query: {
        redebitIds: requestDTO.redebitIds,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(new Blob([result], { type: 'application/octet-stream' }));
  },
});
